import addYears from 'date-fns/addYears';
import compareDesc from 'date-fns/compareDesc';
import format from 'date-fns/format';
import isBefore from 'date-fns/isBefore';
import isValid from 'date-fns/isValid';
import parseISO from 'date-fns/parseISO';
import startOfDay from 'date-fns/startOfDay';

export const formatInvoiceDate = (date, locale) =>
  date
    ? new Date(date).toLocaleDateString(locale, {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      })
    : '-';

export function toDate(value) {
  if (!value) {
    return null;
  }

  if (value instanceof Date) {
    return isValid(value) ? value : null;
  }

  if (typeof value === 'number') {
    const date = new Date(value);
    return isValid(date) ? date : null;
  }

  if (typeof value === 'string') {
    const isoDate = parseISO(value);

    if (isValid(isoDate)) {
      return isoDate;
    }

    const fallbackDate = new Date(value);
    return isValid(fallbackDate) ? fallbackDate : null;
  }

  return null;
}

export function isSameOrAfterToday(value) {
  const date = toDate(value);

  if (!date) {
    return false;
  }

  return !isBefore(startOfDay(date), startOfDay(new Date()));
}

export function isSameOrAfterDate(value, comparisonValue) {
  const date = toDate(value);
  const comparisonDate = toDate(comparisonValue);

  if (!date || !comparisonDate) {
    return false;
  }

  return !isBefore(startOfDay(date), startOfDay(comparisonDate));
}

export function sortByDateDesc(dateA, dateB) {
  const parsedDateA = toDate(dateA);
  const parsedDateB = toDate(dateB);

  if (!parsedDateA && !parsedDateB) {
    return 0;
  }

  if (!parsedDateA) {
    return 1;
  }

  if (!parsedDateB) {
    return -1;
  }

  return compareDesc(parsedDateA, parsedDateB);
}

export function addYearsToDate(value, amount) {
  const date = toDate(value);

  if (!date) {
    return null;
  }

  return addYears(date, amount);
}

export function formatDate(value, pattern = 'dd/MM/yyyy') {
  const date = toDate(value);

  if (!date) {
    return '';
  }

  return format(date, pattern);
}

export function formatYear(value) {
  return formatDate(value, 'yyyy');
}
